// extracted by mini-css-extract-plugin
export default {"content-root":"_3Jlkm","contentRoot":"_3Jlkm","title":"_1Dtgd","message":"_2QNuX","image":"_3Xjn9"};